__turbopack_context__.v({
  "expandBtn": "_4ADt_G_expandBtn",
  "gallery": "_4ADt_G_gallery",
  "lightboxClose": "_4ADt_G_lightboxClose",
  "lightboxContent": "_4ADt_G_lightboxContent",
  "lightboxCounter": "_4ADt_G_lightboxCounter",
  "lightboxImageWrap": "_4ADt_G_lightboxImageWrap",
  "lightboxNavLeft": "_4ADt_G_lightboxNavLeft",
  "lightboxNavRight": "_4ADt_G_lightboxNavRight",
  "lightboxOverlay": "_4ADt_G_lightboxOverlay",
  "mainImage": "_4ADt_G_mainImage",
  "mainStage": "_4ADt_G_mainStage",
  "navBtn": "_4ADt_G_navBtn",
  "navBtnLeft": "_4ADt_G_navBtnLeft",
  "navBtnRight": "_4ADt_G_navBtnRight",
  "thumb": "_4ADt_G_thumb",
  "thumbActive": "_4ADt_G_thumbActive",
  "thumbnails": "_4ADt_G_thumbnails",
});
